export default __webpack_public_path__ + "static/media/slogan_large.6590b15a.png";